import { useCallback, useMemo } from 'react'

import {
  useDeleteDashBoardProfile,
  useListDashBoardProfile
} from 'interface/dashBoardProfile'

import { SearchDetailResult } from 'interface/search'

type useDashBoardProfileListProps = {
  profileKey: string
  search: SearchDetailResult | null
  userId: number | undefined
  onDeleteProfileReply: (deletedProfileId: number) => void
}

export const useDashBoardProfileList = ({
  profileKey,
  search,
  userId,
  onDeleteProfileReply
}: useDashBoardProfileListProps) => {
  const listState = useListDashBoardProfile(profileKey, search?.searchId)
  const profiles = useMemo(
    () => {
      if (!listState.data) return null

      const profileList = listState.data.list
      const bySearchList = profileList.filter((profile) => profile.searchId && profile.userId === userId)
      const byUserList = profileList.filter((profile) => !profile.searchId && profile.userId === userId)
      const shareUserList = profileList.filter((profile) => profile.isShared && profile.userId !== userId)
      return {
        bySearchList,
        byUserList,
        shareUserList
      }
    },
    [listState.data, userId]
  )
  const onDeleted = useCallback(
    (deletedProfileId: number) => {
      onDeleteProfileReply(deletedProfileId)
      listState.refetch()
    },
    [listState, onDeleteProfileReply]
  )
  const [deleteProfileState, deleteProfile] = useDeleteDashBoardProfile(profileKey, { onDeleted })

  return {
    isLoading: listState.loading,
    error: listState.error,
    bySearchProfiles: profiles?.bySearchList,
    byUserProfiles: profiles?.byUserList,
    sharedProfiles: profiles?.shareUserList,
    deleteProfileState,
    deleteProfile
  }
}
